import React from 'react';

import './userCenterActionBar.scss';
import {DropdownMenu, DropdownMenuLink} from '../../../../../@elixir/router';
import {Button} from '../../../../../@elixir/components';
import {GetRequest} from '../../../common/service/GetRequest';
import PropTypes from 'prop-types';
import {MultiSelectControlButtons} from './multiSelectControlButtons/multiSelectControlButtons';
import {MultiSelectTitle} from './multiSelectTitle/multiSelectTitle';

export class UserCenterActionBar extends React.Component {

    static contextTypes = {
        translator: PropTypes.func,
        onSelectAction: PropTypes.func,
        onTakeAction: PropTypes.func,
        onCancelAction: PropTypes.func,
        selectedAction: PropTypes.object,
        selectionCount: PropTypes.number
    };

    constructor (props) {
        super(props);
        this.state = {actions: []};
    }

    componentDidMount () {
        const profileUrl = '/rest/Actions?uri=com.firstbest.user.UserTrack:null';

        new GetRequest(profileUrl).then(
            (result) => {
                const actionLabelKeyMap = {
                    forceLogout: 'userCenter.action.forceLogout',
                    broadcastMessage: 'userCenter.action.broadcast'
                };
                const actionList = _.map(result.actions, (item) => {
                    return {
                        id: item.name,
                        labelKey: actionLabelKeyMap[ item.name ]
                    };
                });

                this.setState({actions: actionList});
            }
        );
    }

    onSelectMenuItem (action, event) {
        event.preventDefault();
        this.props.onSelectAction(action);
    }

    render () {
        const {
            actions
        } = this.state;

        const {
            selectedAction,
            selectionCount,
            onTakeAction,
            onCancelAction,
            multiSelectMode
        } = this.props;

        let actionsDropdown = '';
        let actionSelectionButtonList = '';

        if (selectedAction === '') {
            actionsDropdown = (
                <DropdownMenu
                    className="userProfileMenuComponent"
                    renderTrigger={(props, toggleMenu) => {
                        const {isOpen, className} = props;
                        const handleButtonClick = () => {
                            toggleMenu(!isOpen);
                        };

                        return <Button className="actionDropdownMenuButton"
                                       name="actionButton"
                                       type="neutral"
                                       size="small"
                                       icon="fa-chevron-down"
                                       iconPosition="right"
                                       onClick={handleButtonClick.bind(this)}>
                            <span>Actions</span>
                        </Button>;
                    }}
                    dropUp={false}
                    alignRight={true}
                    showCaret={false}>

                    {actions.map((action, index) => {
                        const actionLabel = this.context.translator(action.labelKey);
                        return <DropdownMenuLink key={action.id}
                                                 onClick={this.onSelectMenuItem.bind(this, {
                                                     actionId: action.id,
                                                     actionLabel: actionLabel
                                                 })}>
                            <span>{actionLabel}</span>
                        </DropdownMenuLink>
                    })}

                </DropdownMenu>
            );
        }
        else {

            actionSelectionButtonList = (
                <MultiSelectControlButtons
                    onTakeAction={onTakeAction}
                    onCancel={onCancelAction}
                    selectionCount={selectionCount}
                    selectedAction={selectedAction}
                />
            );
        }

        const title = (<h1 className="actionBarTitle">Active Sessions</h1>);
        const multiSelectTitle = (
            <MultiSelectTitle
                titleText={'Active Sessions Selected'}
                selectionCount={selectionCount}
            />
        );

        return (
            <div className="userCenterActionBarComponent ">

                {multiSelectMode ? multiSelectTitle : title}

                {actionsDropdown}
                {actionSelectionButtonList}
            </div>
        );
    }
}

